module.exports = __webpack_public_path__ + "static/media/arrow.66a184f6.svg";